/**
 *  Initialize Carousel
 */

var carousel = (function() {
  var pub = {}; // public facing functions

  pub.init = function() {
    $('.carousel').each(function() {
      var $carousel = $(this);
		var slidesToShow = $carousel.data('slides-to-show');

		$carousel.on('init', function (ev, slick) {
			setTimeout(function () {
				if (slick.slideCount <= slick.options.slidesToShow) {
					$carousel.find('#carouselBtnDiv').hide();
				}
			});
		});


      $carousel.find('.carousel__items').slick({
        appendArrows: $carousel,
		infinite: false,
		arrows:false,
        nextArrow:
          '<button type="button" class="slick-next"><svg class="icon--arrow-right"><use xlink:href="/svg/icons.svg#icon--arrow-right"></svg></button>',
        prevArrow:
          '<button type="button" class="slick-prev"><svg class="icon--arrow-left"><use xlink:href="/svg/icons.svg#icon--arrow-left"></svg></button>',
        responsive: [
          {
            breakpoint: 991,
            settings: { slidesToShow: Math.max(slidesToShow - 2, 1) }
          },
          {
            breakpoint: 767,
            settings: { slidesToShow: Math.max(slidesToShow - 3, 1) }
          },
          {
            breakpoint: 575,
            settings: { slidesToShow: Math.max(slidesToShow - 3, 1) }
		  },
		  {
            breakpoint: 450,
            settings: { slidesToShow: Math.max(slidesToShow - 4, 1) }
		  },
		  {
			  breakpoint: 400,
			  settings: { slidesToShow: Math.max(slidesToShow - 4, 1) }
		  }
        ],
        slidesToShow: slidesToShow,
        swipeToSlide: true
	  });

	  window.setCarouselButtons = function (el) {
		  if ($(el).find('.slick-list').find('#carouselBtnDiv').length === 0) {
			  $(el).find('.slick-list').prepend('<div id="carouselBtnDiv" style="text-align:right;margin-bottom:10px"><button type="button" onclick="window.carouselMove(\'prev\', event)" id="btnCarouselPrev" class="btn btn-primary carousel-custom-arrow" aria-disabled="false" title="Move carousel to previous"><svg class="icon--arrow-down"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/svg/icons.svg#icon--arrow-left"></use></svg></button><button onclick="window.carouselMove(\'next\', event)" id="btnCarouselNext" type="button" class="btn btn-primary carousel-custom-arrow" aria-disabled="false" title="Move carousel next"><svg class="icon--arrow-down"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/svg/icons.svg#icon--arrow-right"></use></svg></button></div>');
		  }
	  }

	  $carousel.find('.carousel__items').on('breakpoint', function (ev, slick, breakpoint) {
		  window.setCarouselButtons($carousel.find('.carousel__items'));
		});
	

	  $carousel.find('.carousel__items').on('afterChange', function (event, slick, currentSlide) {
		  //var slidesToShow = slick.options.slidesToShow;
		  //var totalSlides = slick.$slides.length;
		  //var pointToDisableNextArrow = totalSlides - slidesToShow;
		  //if (currentSlide == pointToDisableNextArrow) {
			 // $(slick.$list).find('#btnCarouselNext').hide();
		  //} else {
			 // $(slick.$list).find('#btnCarouselNext').show();
		  //}
		  //if (currentSlide === 0) {
			 // $(slick.$list).find('#btnCarouselPrev').hide();
		  //} else {
			 // $(slick.$list).find('#btnCarouselPrev').show();
		  //}
	  });
	  window.setCarouselButtons(this);
	  });

	

	window.carouselMove = function (position, e) {
		var pos = position === "prev" ? "slickPrev" : "slickNext";
		$(e.target).parents('.carousel__items').slick(pos);
		//console.log($(e.target).parents('.carousel__items').slick("slidesToShow"))
	}
  };

  return pub;
})(jQuery);
